<template>
    <span>
        <v-dialog max-width="600px">
        <span column slot="activator" class="fab-container">
            <v-btn fab  dark large color="brown darken-4" fixed right bottom><v-icon>person_add</v-icon></v-btn>
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>ADD NEW STAFF</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
                
                Default password for new staff is <b>pass123</b>
             </v-card-text>
             <v-card-text>
                <v-form class="px-3" ref="form"> 
                     <v-text-field label="Username*" v-model="username"  @keypress="isName" :rules="usernameRules" prepend-icon="person"></v-text-field>
                     <v-text-field label="Password*" v-model="password" :rules="passRules" readonly prepend-icon="lock"></v-text-field>
                     <v-text-field label="Full Name*" v-model="name" :rules="nameRules" prepend-icon="comment"></v-text-field>
                     <v-text-field label="Email Address" v-model="email" prepend-icon="mail"></v-text-field>
                     <v-text-field label="Phone number" v-model="phone"  @keypress="isNumber" prepend-icon="phone"></v-text-field>
                    <v-select label="Campus*" item-text="campus" :items="camp" v-model="camps"  prepend-icon="contacts"></v-select>
                    
                     <v-select label="Gender*" item-text="gender" :items="[{header:'Gender'},'male','female']" v-model="gender"  prepend-icon="contacts"></v-select>
                     <v-select label="Rights*" item-text="rights" multiple :items="roles" v-model="rights"  prepend-icon="contacts"></v-select>
                    <span v-if="error_state" class="red--text">{{error_value}}</span>
                    <span> * indicates required field </span>
                </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isDisabled" >Add Staff</v-btn>
             </v-card-actions>
         </v-card>
        </v-dialog>
   </span>
</template>

<script>
import {addModule} from '@/model';
import moment from 'moment';
import {loadCampus} from '@/validator'

export default {
    name: 'AddStaff',
    data() {
        return {
         isDisabled:false,
         error_state:false,
         error_value:'You must supply a gender',
         username:'',
         password:'pass123',
         name:'',
         gender:[],
         email:'',
         camps:[],
         camp:loadCampus([{header:'Supers'},'all',{header:'Normal'}],this.$store.getters.getCampus),
         rights:[],
         roles:[
             {header:'Super'},
              '003','007','011','012','013','014','015','018',
              {header:'Average'},
              '001','002','004','005','008','009','016','017','019','020','022','023',
              {header:'Normal'},
              '006','010','021'
             ],
         phone:'',
         usernameRules:[
               v => v.length >=5  || "Minimum length is 5 characters",
               v => v.length <=20  || "Maximum length is 20 characters",
               
           ],
        passRules:[
               v => v.length >=4  || "Minimum length is 4 characters",
               v => v.length <=20  || "Maximum length is 20 characters" 
           ],
        nameRules:[
               v => v.length >=5  || "Minimum length is 5 characters",
               v => v.length <=30  || "Maximum length is 30 characters" 
           ]

        };
    },
    methods: {
        isName:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if(charcode !== 46 && charcode !== 32){
                return true;
            }else{
                evt.preventDefault();
            }
        },
        isNumber:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) || charcode == 46){
                evt.preventDefault();
            }else{
                return true;
            }
        },
        add() {
            let self=this;
            if(this.$refs.form.validate()){
            let datenow = moment().format('DD/MM/YYYY');
            
            if(this.camps.length==0){
                    self.error_state = true;
                    self.error_value = "Staff must be assigned a campus"
                    return
            }else if(this.gender.length==0){
                    self.error_state = true;
                    self.error_value = "Staff must be assigned a gender"
                    return
            }else{
                if(this.rights.length==0){
                    self.error_state = true;
                    self.error_value = "Staff must be assigned at least one right"
                    return
                }
            }
             self.error_state = false;
            let useradd = this.$store.getters.getStaff.name;
            console.log(useradd); 
            
            let newitem = {name:this.username.toLowerCase(),password:this.password,fullname:this.name,campus:this.camps.toLowerCase(),gender:this.gender,email:this.email,phone_no:this.phone,rights:this.rights,dateadded:datenow,useradd:useradd};
            console.log(newitem);
            self.isDisabled = true;
           
              addModule('staff',this.username.toLowerCase(),newitem,function(response){
                  if(response){
                      console.log("This is response: ",response);
                      alert('Staff has been successfully added');
                    self.$store.dispatch('updateStaffs');
                    self.isDisabled = false;
                  }else{
                      console.log("Unknown Error occured.");
                      self.isDisabled = false;
                  }

               })
            }
        }
    }
};
</script>

<style scoped>
</style>